import { SunThermometerOutlineIcon } from './SunThermometerOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A92400D5-89B6-46B0-9D55-4980BE45C51D
 * name sun-thermometer-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-thermometer-outline.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const OutsideTemperatureIcon = SunThermometerOutlineIcon;
export default OutsideTemperatureIcon